module.exports = __webpack_public_path__ + "static/tradee_img2-c8c46ac5c05f72149ad2902609678faa.png";